// Description: Sidebar functionality.
//
// Refactored to use ES6 syntax and functions.

/**
 * Global sidebar variables.
 */
let sidebarTabEventListenersAdded = false;

/**
 * Sets up the sidebar tab swapping functionality.
 */
const setupSidebarTabSwapping = () => {
    const tabStripTabs = document.querySelectorAll(".rtsLI");
    tabStripTabs.forEach(tabStripTab => {
        if (tabStripTab.classList.contains("js-sidebar-tabs-row-1")) {
            tabStripTab.style.order = 1;
        } else if (tabStripTab.classList.contains("js-sidebar-tabs-row-2")) {
            tabStripTab.style.order = 2;
        }
    });

    if (!sidebarTabEventListenersAdded) {
        tabStripTabs.forEach(tabStripTab => {
            tabStripTab.addEventListener('click', event => {
                if (tabStripTab.style.order == 2) {
                    tabStripTabs.forEach(tabStripItem => {
                        if (tabStripItem.style.order == 1) {
                            tabStripItem.style.order = 2;
                        } else if (tabStripItem.style.order == 2) {
                            tabStripItem.style.order = 1;
                        }
                    });
                }
            });
        });
        sidebarTabEventListenersAdded = true;
    }
};
